import { type ReactNode, createContext, useContext } from 'react';

const DynamicNamespaceContext = createContext<string | undefined>(undefined);

export const useDynamicNamespace = (fallbackNamespace = 'lib-global-common') => {
  const context = useContext(DynamicNamespaceContext);

  if (context === undefined) {
    return fallbackNamespace;
  }

  return context;
};

// Provide dynamic namespace on the pages that require custom translations. Child components will use the custom translation namespace or fallback to the default one.
// This is useful for pages that have the issue with extensive translations passed via props.
export function DynamicNamespaceProvider({ children, namespace }: { children: ReactNode; namespace: string }) {
  return <DynamicNamespaceContext.Provider value={namespace}>{children}</DynamicNamespaceContext.Provider>;
}

// Usage example:
// const dynamicNamespace = useDynamicNamespace('lib-global-common');
// const { t } = useTranslation([dynamicNamespace]);
